// Shared OrionChat block model — the message/block types rendered by @artemis-ui/orion-chat.
// They live here (top of the import hierarchy) so transport adapters in @logz-pkg/frontend-services
// can produce them without depending on a UI package; @artemis-ui/orion-chat re-exports them so its
// public API is unchanged. Declared as `type` (not `interface`) to keep the contract names un-prefixed.
// Which OrionIQ surface a chat run came from (ORIONIQ-1475). CLOSED, unlike ChatMode: a surface is a whole
// client application, so a fourth one is a code change in every repo anyway — nothing is gained by making it
// open. Persisted per-run on `oiq_agents_history.origin` and surfaced as a conversation's
// `startedOn` / `lastUsedOn`.
//
// It cannot be set by the shared transport (`@logz-pkg/frontend-services` `agentsApiService.generalAgentChat`
// is the one send site for BOTH web surfaces, so it would give them the same value) — each host injects it
// into the request body it already builds.
export const ChatOrigin = {
    // The OrionIQ mobile companion app.
    mobile: 'mobile',
    // The standalone OrionIQ web app (Artemis `apps/orioniq`).
    orioniq: 'orioniq',
    // The OrionIQ chat drawer inside Open 360 (`app-ui`).
    open360: 'open360',
};
//# sourceMappingURL=orion-chat.js.map